export default theme => ({
  container: {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.grey.main,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  title: {
    paddingBottom: theme.spacing(1),
  },
  titleSep: {
    width: 70,
    height: 4,
    backgroundColor: theme.palette.grey.main,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  buttonPdf: {
    marginBottom: theme.spacing(6),
  },
  pictosContainer: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      marginBottom: theme.spacing(2),
    },
  },
  pictoContainer: {
    padding: 0,
    width: 120,
    height: 120,
    [theme.breakpoints.down('lg')]: {
      width: 90,
      height: 90,
    },
    [theme.breakpoints.down('sm')]: {
      width: 80,
      height: 80,
    },
  },
  nextButton: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      position: 'absolute',
      right: theme.spacing(1),
      top: '50%',
      transform: 'translateY(-50%)',
    },
  },
  pictoDisabled: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  itemsContainer: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    position: 'relative',
  },
  itemContainer: {
    whiteSpace: 'normal',
    display: 'inline-block',
  },
  itemDisabled: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  itemGrid: {
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      width: '100%',
      '& > *': {
        paddingLeft: '0 !important',
        paddingRight: '0 !important',
      },
    },
  },
  subtitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },
  titleContent: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  desc: {
    padding: theme.spacing(2),
  },
  desc3: {
    color: theme.palette.common.white,
  },
  title_foncier: {
    color: theme.palette.green.main,
  },
  desc3_foncier: {
    backgroundColor: theme.palette.green.main,
    // color: theme.palette.green.contrastText,
  },
  title_matiere: {
    color: theme.palette.yellow.main,
  },
  desc3_matiere: {
    backgroundColor: theme.palette.yellow.main,
    // color: theme.palette.yellow.contrastText,
  },
  title_energie: {
    color: theme.palette.blue.light,
  },
  desc3_energie: {
    backgroundColor: theme.palette.blue.light,
    // color: theme.palette.blue.contrastText,
  },
  title_eau: {
    color: theme.palette.green.light,
  },
  desc3_eau: {
    backgroundColor: theme.palette.green.light,
    // color: theme.palette.green.contrastText,
  },
  title_chantier: {
    color: theme.palette.purpule.main,
  },
  desc3_chantier: {
    backgroundColor: theme.palette.purpule.main,
    // color: theme.palette.pink.contrastText,
  },
  title_menage: {
    color: theme.palette.orange.main,
  },
  desc3_menage: {
    backgroundColor: theme.palette.orange.main,
    // color: theme.palette.orange.contrastText,
  },
  title_bio: {
    color: theme.palette.blue.main,
  },
  desc3_bio: {
    backgroundColor: theme.palette.blue.main,
    // color: theme.palette.blue.contrastText,
  },
});
